import React, { useContext, useState } from "react";
import { Context } from "../provider";
import ProfileImageView from "../../profileImageView/ProfileImageView";

const ChangeProfile = () => {
    const [openProfileView, setOpenProfileView] = useState(false);

    const { state, dispatch } = useContext(Context);
    const { ftm, ftm_profile_image } = state;
    const { ftm_profile_image_path, ftm_forename, ftm_surname, ftm_postcode } = ftm;

    const handleOpenProfileView = () => setOpenProfileView(true);
    const handleCloseProfileView = () => setOpenProfileView(false);

    const handleImageChange = (event) => {
        dispatch({
            type: 'SET_FTM_PROFILE_IMAGE',
            ftm_profile_image: event.target.files[0]
        });
    };

    const profileImageSrc = ftm_profile_image
        ? URL.createObjectURL(ftm_profile_image)
        : (ftm_profile_image_path || '/assets/img/lock_user.png');

    return (
        <div className="card card-body" id="profile">
            <div className="row justify-content-center align-items-center">
                <div className="col-sm-auto col-4">
                    <div className="avatar avatar-xl position-relative">
                        <img
                            src={profileImageSrc}
                            alt="profile"
                            className="w-100 rounded-circle shadow-sm cursor-pointer"
                            style={{ height: '100%' }}
                            onClick={handleOpenProfileView}
                        />

                        <ProfileImageView show={openProfileView} closeModal={handleCloseProfileView} imagePath={profileImageSrc || "/assets/img/lock_user.png"}/>
                    </div>
                </div>
                <div className="col-sm-auto col-8 my-auto">
                    <div className="h-100">
                        <h5 className="mb-1 font-weight-bolder">
                            {ftm_forename} {ftm_surname}
                        </h5>
                        <p className="mb-0 font-weight-normal text-sm">
                            POSTCODE #{ftm_postcode}
                        </p>
                    </div>
                </div>
                <div className="col-sm-auto ms-sm-auto mt-sm-0 mt-3 d-flex">
                    <div>
                        <input
                            type="file"
                            id="upload"
                            hidden
                            onChange={handleImageChange}
                        />
                        <label
                            htmlFor="upload"
                            style={{
                                display: "inline-flex", // 👈 use flex
                                alignItems: "center",   // 👈 vertically center icon & text
                                gap: "6px",             // 👈 small space between icon and text
                                backgroundColor: "#212529",
                                color: "white",
                                padding: "0.4rem 0.8rem",
                                fontFamily: "sans-serif",
                                borderRadius: "0.3rem",
                                cursor: "pointer",
                                marginTop: "15px",
                            }}
                        >
                            <i className="material-icons text-lg">photo_camera</i>
                            <span>UPLOAD</span>
                        </label>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ChangeProfile;